import { render, staticRenderFns } from "./ProjectAddCardComponent.vue?vue&type=template&id=67a9b4f9&scoped=true&"
import script from "./ProjectAddCardComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectAddCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAddCardComponent.vue?vue&type=style&index=0&id=67a9b4f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a9b4f9",
  null
  
)

export default component.exports